import React, { useState } from 'react';
import SelectDropdown from 'components/base/select-dropdown';
import CurrencyInput from 'components/base/currency-input';
import useVendorContext from 'contexts/vendor.context';
import { VendorItemType } from 'models/vendors.model';
import { ENUM_UNIT } from 'models/common.model';
import useDashboardContext from 'contexts/dashboard.context';

const AddVendorStoreItems = () => {
  const { vendorFormData, setVendorFormData } = useVendorContext();
  const defaultShowStoreItems = vendorFormData.reduce((result, _, index) => {
    result[index] = false;
    return result;
  }, {} as Record<string, boolean>);
  const { formStoreItems } = useDashboardContext();
  const [showStoreItems, setShowStoreItems] = useState(defaultShowStoreItems);

  const addItems = (vendorIndex: number) => {
    const newVendors = [...vendorFormData];
    const newVendor = newVendors.find((_, i) => i === vendorIndex);
    if (!newVendor) return;
    newVendor.store_items = [...newVendor.store_items, { ingredient_id: '', gram_price: '' }];
    setVendorFormData(newVendors);
  };
  const removeItems = (vendorIndex: number, itemIndex: number) => {
    const newVendors = [...vendorFormData];
    const newVendor = newVendors.find((_, i) => i === vendorIndex);
    if (!newVendor) return;
    newVendor.store_items = newVendor.store_items.filter((_, idx) => idx !== itemIndex);
    setVendorFormData(newVendors);
  };

  const handleInputChange = (
    vendorIndex: number,
    itemIndex: number,
    value: string | number | ENUM_UNIT,
    name: keyof VendorItemType
  ) => {
    const newVendors = [...vendorFormData];
    const newVendor = newVendors.find((_, i) => i === vendorIndex);
    if (!newVendor) return;
    const newItems = newVendor?.store_items.map((b) => ({ ...b }));
    newItems[itemIndex][name] = value as any;
    newVendor.store_items = newItems;
    setVendorFormData(newVendors);
  };

  const toggleShowStoreItems = (idx: number) => {
    const showItems = showStoreItems[idx];
    setShowStoreItems((vendors) => ({
      ...vendors,
      [idx]: !showItems
    }));
  };

  const selectedIngredient = (id: string) => {
    return id
      ? formStoreItems.filter((ingredient) => ingredient.id === id)[0]
      : { name: '', unit_type: '' };
  };

  return (
    <div>
      <h3 className='text-xl font-semibold mb-6'>Provide vendor store items</h3>
      {vendorFormData.map((vendor, vendorIndex) => (
        <div key={vendorIndex}>
          <div className='bg-[#F7F7F7E5] border-b border-[#EAEBEB] py-3 mx-[-28px] flex justify-between'>
            <p className='text-[16px] font-medium pl-[28px]'>{vendor.name}</p>

            <div
              onClick={() => toggleShowStoreItems(vendorIndex)}
              className='bg-white border border-[#EAEBEB] rounded-[100px] px-4 py-2 text-xs font-medium text-[#5E6164] cursor-pointer mr-[28px]'>
              {showStoreItems[vendorIndex] ? 'Hide' : 'Show'}
            </div>
          </div>
          {showStoreItems[vendorIndex] ? (
            vendor.store_items?.length > 0 ? (
              vendor.store_items.map(({ gram_price, ingredient_id }, itemIndex) => (
                <div key={itemIndex}>
                  <div className='grid grid-cols-2 gap-6 w-[100%] mt-4'>
                    <SelectDropdown
                      label='Item name'
                      placeholder='Select item'
                      value={selectedIngredient(ingredient_id).name}
                      setValue={(item) =>
                        handleInputChange(vendorIndex, itemIndex, item.id, 'ingredient_id')
                      }
                      options={formStoreItems}
                      hasSearch
                    />
                    <CurrencyInput
                      name='price'
                      label='Price per qty'
                      placeholder=' 2,000'
                      hasUnit
                      disableUnit
                      explicitRender
                      value={gram_price}
                      unitValue={selectedIngredient(ingredient_id).unit_type}
                      decimalsLimit={2}
                      onChange={(value) =>
                        handleInputChange(vendorIndex, itemIndex, value, 'gram_price')
                      }
                    />
                  </div>
                  <div className='flex justify-end'>
                    {
                      <button
                        onClick={() => removeItems(vendorIndex, itemIndex)}
                        className='text-[#E60A2B] mt-1 font-medium text-sm '>
                        - Remove Item
                      </button>
                    }
                  </div>
                  <button
                    onClick={() => addItems(vendorIndex)}
                    className='text-[#0080E5] font-medium text-sm mt-1'>
                    + Add Item
                  </button>
                </div>
              ))
            ) : (
              <div className='py-3'>
                <h4>No store items</h4>
                <button
                  onClick={() => addItems(vendorIndex)}
                  className='text-[#0080E5] font-medium text-sm mt-2'>
                  + Add Item
                </button>
              </div>
            )
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default AddVendorStoreItems;
